module.exports = __webpack_public_path__ + "static/media/video-consultation-banner.0ab472f6.png";